export namespace PaymentMethodConstants {
  export const BANK = 'US Bank Account';
  export const PAYPAL = 'Paypal';

  // We need to be using codes instead of names as they are not subject to change. We can refactor the above at a later date
  export const CARD = 'CC';
  export const CASH = 'CASH';
  export const TICKET = 'TICK';
  export const PAWPASS = 'PAW';
  export const RIDEPASS = 'PASS';
  export const MULTIRIDEPASS = 'MPASS';
  export const CONFIRMATION = 'CONF';
}
